import { render, staticRenderFns } from "./planContribute.vue?vue&type=template&id=f66f7142&scoped=true&"
import script from "./planContribute.vue?vue&type=script&lang=js&"
export * from "./planContribute.vue?vue&type=script&lang=js&"
import style0 from "./planContribute.vue?vue&type=style&index=0&id=f66f7142&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66f7142",
  null
  
)

export default component.exports